import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { paymentApi } from '../../services/payment';

interface PaymentState {
  selectedPayment: any | null;
  filters: {
    sortBy: string | null;
    sortOrder: 'asc' | 'desc';
  };
  pagination: {
    page: number;
    limit: number;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: PaymentState = {
  selectedPayment: null,
  filters: {
    sortBy: null,
    sortOrder: 'desc',
  },
  pagination: {
    page: 1,
    limit: 10,
  },
  isLoading: false,
  error: null,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setSelectedPayment: (state, action: PayloadAction<any | null>) => {
      state.selectedPayment = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<PaymentState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.page = 1;
    },
    setPagination: (state, action: PayloadAction<Partial<PaymentState['pagination']>>) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearPayment: (state) => {
      state.selectedPayment = null;
      state.error = null;
    },
    resetFilters: (state) => {
      state.filters = {
        sortBy: null,
        sortOrder: 'desc',
      };
      state.pagination.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        paymentApi.endpoints.getPayments.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        paymentApi.endpoints.getPayments.matchFulfilled,
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        paymentApi.endpoints.getPayments.matchRejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.error.message || 'Помилка завантаження платежів';
        }
      );
  },
});

export const {
  setSelectedPayment,
  setFilters,
  setPagination,
  setLoading,
  setError,
  clearPayment,
  resetFilters,
} = paymentSlice.actions;

export default paymentSlice.reducer; 